import Vue from 'vue';
import Amplify from 'aws-amplify';
import i18n from '@/i18n';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import App from './App.vue';
import router from './router';

Amplify.configure({
  Auth: {
    // identityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID,
    region: process.env.VUE_APP_AWS_REGION,
    userPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
    mandatorySignIn: true,
    authenticationFlowType: 'USER_PASSWORD_AUTH', // [cherry] migrate user pool
  },
  API: {
    endpoints: [
      {
        name: 'API',
        endpoint: `https://${process.env.VUE_APP_API_GATEWAY_ID}.execute-api.${process.env.VUE_APP_AWS_REGION}.amazonaws.com/Prod`,
      },
      {
        name: 'UserAPI',
        endpoint: `https://${process.env.VUE_APP_API_GATEWAY_USER_ID}.execute-api.${process.env.VUE_APP_AWS_REGION}.amazonaws.com/Prod/users`,
      },
      {
        name: 'EcPayAPI',
        endpoint: `${process.env.VUE_APP_API_GATEWAY_ECPAY_ENDPOINT}`,
      },
    ],
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
